(function(){
  "use strict";

  const WHATSAPP_NUMBER = (window.themeSettings && window.themeSettings.whatsapp) || "";

  function toast(msg){
    let el = document.getElementById('toast');
    if (!el){ el = document.createElement('div'); el.id='toast'; document.body.appendChild(el); }
    el.textContent = msg; el.classList.add('show');
    clearTimeout(toast._t); toast._t = setTimeout(()=>el.classList.remove('show'), 2600);
  }
  function money(cents){
    return "R$ " + (cents/100).toLocaleString('pt-BR', {minimumFractionDigits:2, maximumFractionDigits:2});
  }

  /* ---------------- Cart drawer ---------------- */
  const overlay = document.getElementById('cart-overlay');
  const drawer = document.getElementById('cart-drawer');
  function openCart(){ overlay?.classList.add('active'); drawer?.classList.add('active'); }
  function closeCart(){ overlay?.classList.remove('active'); drawer?.classList.remove('active'); }
  document.getElementById('open-cart')?.addEventListener('click', (e)=>{ e.preventDefault(); openCart(); refreshCartDrawer(); });
  document.getElementById('close-cart')?.addEventListener('click', closeCart);
  overlay?.addEventListener('click', closeCart);
  document.addEventListener('keydown', e=>{ if (e.key==='Escape') closeCart(); });

  function cartLineHtml(item){
    const img = item.image ? item.image.replace(/(\.[a-zA-Z0-9]+)(\?|$)/, '_120x120$1$2') : '';
    return `
      <div class="cart-line" data-line-key="${item.key}">
        <img src="${img}" alt="" loading="lazy">
        <div class="info">
          <div class="t">${item.product_title}</div>
          <div class="a">${item.vendor || ''}</div>
          <div class="row">
            <div class="qty-stepper">
              <button type="button" data-qty-minus="${item.key}">−</button>
              <input type="text" readonly value="${item.quantity}">
              <button type="button" data-qty-plus="${item.key}">+</button>
            </div>
            <button class="remove-line" data-remove="${item.key}">Remover</button>
          </div>
        </div>
      </div>`;
  }

  async function fetchCart(){
    const res = await fetch('/cart.js');
    return res.json();
  }

  function renderCart(cart){
    const body = document.getElementById('cart-lines');
    const countEl = document.getElementById('cart-count');
    const subtotalEl = document.getElementById('cart-subtotal');
    const checkoutBtn = document.getElementById('checkout-btn');
    const waBtn = document.getElementById('wa-checkout-btn');
    if (!body) return;

    if (!cart.item_count){
      body.innerHTML = `<div class="empty-state"><strong>Seu carrinho está vazio</strong>Adicione discos do catálogo.</div>`;
    } else {
      body.innerHTML = cart.items.map(cartLineHtml).join('');
      body.querySelectorAll('[data-qty-minus]').forEach(b=>b.addEventListener('click', ()=>changeLine(b.dataset.qtyMinus, -1)));
      body.querySelectorAll('[data-qty-plus]').forEach(b=>b.addEventListener('click', ()=>changeLine(b.dataset.qtyPlus, 1)));
      body.querySelectorAll('[data-remove]').forEach(b=>b.addEventListener('click', ()=>removeLine(b.dataset.remove)));
    }
    if (countEl) countEl.textContent = cart.item_count;
    if (subtotalEl) subtotalEl.textContent = money(cart.total_price);
    if (checkoutBtn) checkoutBtn.disabled = !cart.item_count;
    if (waBtn) waBtn.disabled = !cart.item_count;
    window.__cart = cart;
  }

  async function refreshCartDrawer(){
    try{ renderCart(await fetchCart()); }catch(err){ console.error(err); }
  }

  async function changeLine(key, delta){
    const line = (window.__cart?.items || []).find(i=>i.key===key);
    if (!line) return;
    const qty = Math.max(0, line.quantity + delta);
    await updateLine(key, qty);
  }
  async function removeLine(key){ await updateLine(key, 0); }
  async function updateLine(key, qty){
    try{
      const res = await fetch('/cart/change.js', {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({id:key, quantity:qty})
      });
      const cart = await res.json();
      renderCart(cart);
    }catch(err){ console.error(err); toast("Não foi possível atualizar o carrinho."); }
  }

  window.SeriemoCart = {
    add: async function(variantId, quantity){
      quantity = quantity || 1;
      try{
        const res = await fetch('/cart/add.js', {
          method:'POST', headers:{'Content-Type':'application/json'},
          body: JSON.stringify({items:[{id:variantId, quantity}]})
        });
        if (!res.ok){
          const err = await res.json();
          throw new Error(err.description || 'Erro ao adicionar ao carrinho');
        }
        await refreshCartDrawer();
        openCart();
        toast("Adicionado ao carrinho.");
        return true;
      }catch(err){
        console.error(err); toast(err.message || "Não foi possível adicionar ao carrinho.");
        return false;
      }
    },
    open: openCart,
    close: closeCart,
    refresh: refreshCartDrawer
  };

  document.getElementById('coupon-apply')?.addEventListener('click', function(){
    const input = document.getElementById('coupon-code');
    const code = (input.value || '').trim();
    if (!code) return;
    window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/checkout';
  });

  document.getElementById('checkout-btn')?.addEventListener('click', ()=>{ window.location.href = '/checkout'; });

  document.getElementById('wa-checkout-btn')?.addEventListener('click', ()=>{
    const cart = window.__cart;
    if (!cart || !cart.item_count) return;
    if (!WHATSAPP_NUMBER){ toast("Configure o número de WhatsApp nas configurações do tema."); return; }
    const lines = cart.items.map(i=>`• ${i.product_title} (x${i.quantity}) — ${money(i.final_line_price)}`).join('\n');
    const msg = `Olá! Quero fechar este pedido na Seriemo Discos:\n\n${lines}\n\nTotal: ${money(cart.total_price)}`;
    window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`, '_blank');
  });

  document.getElementById('wa-checkout-page-btn')?.addEventListener('click', async ()=>{
    const cart = window.__cart || await fetchCart();
    if (!cart || !cart.item_count) return;
    if (!WHATSAPP_NUMBER){ toast("Configure o número de WhatsApp nas configurações do tema."); return; }
    const lines = cart.items.map(i=>`• ${i.product_title} (x${i.quantity}) — ${money(i.final_line_price)}`).join('\n');
    const msg = `Olá! Quero fechar este pedido na Seriemo Discos:\n\n${lines}\n\nTotal: ${money(cart.total_price)}`;
    window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`, '_blank');
  });

  refreshCartDrawer();

  /* ---------------- Product-card / add-to-cart buttons on grids ---------------- */
  document.addEventListener('click', function(e){
    const btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault();
    const variantId = btn.dataset.addToCart;
    const qtyEl = document.getElementById('pdp-qty');
    const qty = qtyEl ? (parseInt(qtyEl.value, 10) || 1) : 1;
    window.SeriemoCart.add(variantId, qty);
  });

  /* ---------------- Botão flutuante de WhatsApp ---------------- */
  (function(){
    const wa = document.getElementById('wa-float');
    if (!wa) return;
    try{
      if (sessionStorage.getItem('wa_float_closed') === '1'){ wa.style.display = 'none'; return; }
    }catch(e){}
    document.getElementById('wa-float-close')?.addEventListener('click', function(e){
      e.preventDefault();
      wa.style.display = 'none';
      try{ sessionStorage.setItem('wa_float_closed', '1'); }catch(e){}
    });
  })();

  /* ---------------- Botão "Procurar um disco" (home) — foca a busca em vez de navegar ---------------- */
  document.getElementById('hero-focus-search')?.addEventListener('click', function () {
    const input = document.getElementById('global-search');
    if (!input) return;
    input.scrollIntoView({ behavior: 'smooth', block: 'center' });
    setTimeout(function () { input.focus(); }, 350);
  });

  /* ---------------- Toggle "Por gênero" (home) ---------------- */
  document.getElementById('genre-toggle')?.addEventListener('click', function () {
    document.getElementById('home-genre-chips')?.classList.toggle('open');
    this.classList.toggle('open');
  });

  /* ---------------- Rails com auto-play (Novidades / Destaques) ---------------- */
  function setupAutoRail(rail){
    let paused = false;
    const isMobile = function(){ return window.matchMedia('(max-width:640px)').matches; };
    const intervalMs = isMobile() ? 4400 : 4000;
    const interval = setInterval(function(){
      if (paused || document.hidden) return;
      const step = rail.clientWidth; // avança a tela inteira, no mobile e no desktop
      const atEnd = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4;
      if (atEnd) rail.scrollTo({ left: 0, behavior: 'smooth' });
      else rail.scrollBy({ left: step, behavior: 'smooth' });
    }, intervalMs);
    rail.addEventListener('mouseenter', function(){ paused = true; });
    rail.addEventListener('mouseleave', function(){ paused = false; });
    rail.addEventListener('touchstart', function(){ paused = true; }, { passive: true });
    rail.addEventListener('touchend', function(){ setTimeout(function(){ paused = false; }, 2500); }, { passive: true });
    rail._autoplayInterval = interval;
  }
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('.rail[data-autoplay]').forEach(setupAutoRail);
  }

  /* ---------------- Predictive search (funciona em qualquer par input+resultado) ---------------- */
  function setupPredictiveSearch(searchInput, predictiveBox){
    if (!searchInput || !predictiveBox) return;
    let searchDebounce;
    searchInput.addEventListener('input', function(){
      const q = this.value.trim();
      clearTimeout(searchDebounce);
      if (q.length < 2){ predictiveBox.classList.remove('active'); predictiveBox.innerHTML=''; return; }
      searchDebounce = setTimeout(async ()=>{
        try{
          const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=10&resources[limit_scope]=each&resources[options][unavailable_products]=hide&resources[options][fields]=title,vendor,product_type,variants.title`);
          const data = await res.json();
          const products = data.resources?.results?.products || [];
          predictiveBox.innerHTML = products.length
            ? products.map(p=>`
                <a class="pr-item" href="${p.url}">
                  <img src="${p.image || ''}" alt="">
                  <span><span class="t">${p.title}</span><br><span class="a">${p.vendor || ''}</span></span>
                </a>`).join('')
            : `<div class="pr-item"><span class="a">Nenhum disco encontrado.</span></div>`;
          predictiveBox.classList.add('active');
        }catch(err){ console.error(err); }
      }, 200);
    });
    document.addEventListener('click', (e)=>{
      if (!e.target.closest('.head-search') && !e.target.closest('.home-search-wrap')) predictiveBox.classList.remove('active');
    });
  }
  setupPredictiveSearch(document.getElementById('global-search'), document.getElementById('predictive-results'));
  setupPredictiveSearch(document.getElementById('catalog-search'), document.getElementById('catalog-predictive-results'));

  /* ---------------- Busca "nesta lista" do catálogo: Enter recolhe o teclado e vai pra busca real ---------------- */
  const catalogSearch = document.getElementById('catalog-search');
  catalogSearch?.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    e.preventDefault();
    const q = this.value.trim();
    this.blur(); // recolhe o teclado no celular
    if (q) {
      window.location.href = this.dataset.searchUrl + '?q=' + encodeURIComponent(q) + '&type=product';
    }
  });

  /* ---------------- Product page: gallery, qty, shipping ---------------- */
  document.querySelectorAll('[data-thumb]').forEach(t=>{
    t.addEventListener('click', ()=>{
      const main = document.getElementById('pdp-main-img');
      if (main) main.src = t.dataset.thumb;
      t.closest('.pdp-thumbs')?.querySelectorAll('img').forEach(x=>x.classList.remove('active'));
      t.classList.add('active');
    });
  });

  const qtyInput = document.getElementById('pdp-qty');
  const buyNowQty = document.getElementById('buy-now-qty');
  const maxQty = qtyInput ? (parseInt(qtyInput.dataset.max, 10) || 1) : 1;
  function syncBuyNowQty(){ if (buyNowQty && qtyInput) buyNowQty.value = qtyInput.value; }
  document.getElementById('pdp-qty-minus')?.addEventListener('click', ()=>{
    if (!qtyInput) return;
    qtyInput.value = Math.max(1, (parseInt(qtyInput.value)||1) - 1);
    syncBuyNowQty();
  });
  document.getElementById('pdp-qty-plus')?.addEventListener('click', ()=>{
    if (!qtyInput) return;
    qtyInput.value = Math.min(maxQty, (parseInt(qtyInput.value)||1) + 1);
    syncBuyNowQty();
  });

  const waProductBtn = document.getElementById('pdp-wa');
  waProductBtn?.addEventListener('click', ()=>{
    if (!WHATSAPP_NUMBER){ toast("Configure o número de WhatsApp nas configurações do tema."); return; }
    const title = waProductBtn.dataset.title, artist = waProductBtn.dataset.artist, price = waProductBtn.dataset.price, url = waProductBtn.dataset.url;
    const qty = qtyInput ? qtyInput.value : 1;
    const msg = `Olá! Tenho interesse neste disco na Seriemo Discos:\n\n${title} — ${artist} (x${qty})\n${price}\n${url}`;
    window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`, '_blank');
  });

  const cepBtn = document.getElementById('cep-calc');
  const UF_NAMES = {AC:'Acre',AL:'Alagoas',AP:'Amapá',AM:'Amazonas',BA:'Bahia',CE:'Ceará',DF:'Distrito Federal',ES:'Espírito Santo',GO:'Goiás',MA:'Maranhão',MT:'Mato Grosso',MS:'Mato Grosso do Sul',MG:'Minas Gerais',PA:'Pará',PB:'Paraíba',PR:'Paraná',PE:'Pernambuco',PI:'Piauí',RJ:'Rio de Janeiro',RN:'Rio Grande do Norte',RS:'Rio Grande do Sul',RO:'Rondônia',RR:'Roraima',SC:'Santa Catarina',SP:'São Paulo',SE:'Sergipe',TO:'Tocantins'};
  cepBtn?.addEventListener('click', async ()=>{
    const cepInput = document.getElementById('cep-input');
    const resultEl = document.getElementById('ship-result');
    const cep = (cepInput.value || '').replace(/\D/g,'');
    if (cep.length < 8){ resultEl.textContent = "Digite um CEP válido."; return; }
    resultEl.textContent = "Calculando…";
    const fmtDecimal = (v) => "R$ " + Number(v).toLocaleString('pt-BR', {minimumFractionDigits:2, maximumFractionDigits:2});
    try{
      // 0) busca o endereço completo a partir do CEP — algumas transportadoras
      //    só calculam com cidade/estado preenchidos, não só o CEP sozinho.
      let addrParams = `shipping_address[zip]=${cep}&shipping_address[country]=Brazil`;
      try{
        const viaCepRes = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
        const viaCep = await viaCepRes.json();
        if (viaCep && !viaCep.erro){
          const provinceName = UF_NAMES[viaCep.uf] || viaCep.uf;
          addrParams += `&shipping_address[city]=${encodeURIComponent(viaCep.localidade || '')}`;
          addrParams += `&shipping_address[province]=${encodeURIComponent(provinceName || '')}`;
          addrParams += `&shipping_address[address1]=${encodeURIComponent(viaCep.logradouro || 'S/N')}`;
        }
      }catch(viaCepErr){ console.error('ViaCEP:', viaCepErr); }

      // 1) inicia o cálculo (assíncrono do lado da Shopify)
      await fetch(`/cart/prepare_shipping_rates.json?${addrParams}`, { method: 'POST' });
      // 2) busca o resultado, tentando de novo por alguns segundos até ficar pronto
      let rates = [];
      for (let attempt = 0; attempt < 10; attempt++){
        await new Promise(r => setTimeout(r, 800));
        const res = await fetch(`/cart/async_shipping_rates.json?${addrParams}`);
        if (res.ok){
          const data = await res.json();
          if (data && data.shipping_rates){ rates = data.shipping_rates; break; }
        }
      }
      resultEl.innerHTML = rates.length
        ? rates.map(r=>`<div class="ship-option"><span>${r.presentment_name || r.name}</span><span>${fmtDecimal(r.price)}</span></div>`).join('')
        : `Nenhuma opção de frete encontrada para esse CEP. Adicione o disco ao carrinho primeiro, ou finalize pelo WhatsApp.`;
    }catch(err){
      console.error(err);
      resultEl.textContent = "Para calcular o frete, adicione o disco ao carrinho primeiro — ou finalize pelo WhatsApp.";
    }
  });

})();
